import React from "react";
import TeaserStat from "./TeaserStat";
import Modal from "../../ui/Modal/Modal";

const TeaserStatModal = () => {
  return (
    <Modal
      className="modal-page-wrapper"
      onClose={() => {
        window.history.back();
      }}
    >
      <TeaserStat light isModal />
    </Modal>
  );
};

export default TeaserStatModal;
